import React from "react";
import styled from "styled-components";
import { IconHeadphones, useSiteContext } from "@americanbible/uikit";
import { CloudIcon } from "./CloudIcon";

export const ListItem = styled.div`
  box-sizing: border-box;
  padding: 12px 24px;
  width: 100%;
  transition: background 200ms ease;
  cursor: pointer;
  display: flex;

  ${({ active, theme, selected }) => {
    const activeColor = theme.darkMode ? theme.appBarText : theme.primary;
    return `
      color: ${theme.primaryText};
      ${active &&
        (theme.scriptDirection === "ltr"
          ? `border-left: 5px solid ${activeColor}`
          : `border-right: 5px solid ${activeColor}`)};
    `;
  }};

  &:hover {
    background-color: ${({ theme }) =>
      theme.darkMode ? "#535353" : "#F2F2F2"};
  }
`;

/* Bible List Item Start */
const AudioIconContainer = styled.div`
  width: 20px;
  margin-${props =>
    props.theme.scriptDirection === "ltr" ? "right" : "left"}: 8px;
  flex-shrink: 0;

`;

const BibleDescription = styled.span`
  color: ${({ theme }) => (theme.darkMode ? "rgba(255,255,255,.8)" : "#666")};
  font-size: 14px;
`;

export const BibleListItem = ({ bible, selected, onCloudClick, ...props }) => {
  const { showBibleAbbreviations } = useSiteContext();

  return (
    <ListItem selected={selected} {...props}>
      <AudioIconContainer>
        {bible.audioBibles && bible.audioBibles.length > 0 && (
          <IconHeadphones size={20} />
        )}
      </AudioIconContainer>
      <div>
        {showBibleAbbreviations ? (
          <>
            {bible.abbreviationLocal}
            <br />
            <BibleDescription>{bible.nameLocal}</BibleDescription>
          </>
        ) : (
          bible.nameLocal
        )}
        {onCloudClick && ( // if no handler, hide icon
          <CloudIcon
            offlineState={bible.offlineState}
            bibleId={bible.id}
            onClick={() => onCloudClick(bible.id, bible.offlineState)}
          />
        )}
      </div>
    </ListItem>
  );
};
/* Bible List Item End */

export const ChapterListItem = styled.div`
  display: inline-flex;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  margin-bottom: 10px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 2px;

  &:nth-child(6n) {
    margin-right: 0;
  }

  ${({ active, theme }) => {
    const activeColor = theme.darkMode ? theme.appBarText : theme.primary;
    const color = active ? activeColor : theme.appBarText;
    const bgColor = theme.darkMode ? "#535353" : "#F2F2F2";

    return `
    color: ${color};
    ${active && `background-color: ${bgColor};`}
    & > svg { fill: ${color}; }

    &:hover {
      color: ${activeColor};
      background-color: ${bgColor};
      & > svg { fill: ${activeColor}; }
    }
    `;
  }};
`;
